<template>
  <transition name="fade">
    <div class="loginModal" v-if="show">
      <div class="overlay" v-on:click="close"></div>
      <div :class="{modalContent: true}">
        <div class="close" v-on:click="close"></div>
        <div class="videoCnt">
          <VuePlyr ref="video" :options="{ hideControls: false }">
            <video></video>
          </VuePlyr>
        </div>
        <div class="profileInfo" v-if="d">
          <button v-on:click="support">Dukung</button>
          <h4>{{d.name}}<span v-if="d.organization">{{d.organization}}</span></h4>
          <p v-if="viewMore">{{d.profile}}</p>
          <p v-else>{{d.profileShort}}</p>
          <div class="viewMore" v-on:click="viewMore = false"
            v-if="viewMore">Lebih sedikit</div>
          <div class="viewMore" v-on:click="viewMore = true" v-else>Lebih banyak</div>
        </div>
      </div>
      <SupportDialog ref="supportDialog"/>
    </div>
  </transition>
</template>

<script>
import VuePlyr from 'vue-plyr';
import 'vue-plyr/dist/vue-plyr.css';
import SupportDialog from '@/components/SupportDialog.vue';

export default {
  components: { VuePlyr, SupportDialog },
  props: {
  },
  data() {
    return {
      show: false,
      loading: false,
      next: null,
      d: null,
      viewMore: false,
    };
  },
  methods: {
    close(ok) {
      this.show = false;
      document.querySelector('body').classList.remove('ofw-hdn');
      if (this.next) this.next(ok);
    },
    support() {
      this.$refs.supportDialog.open(this.d);
      this.$http.get(this.$config.uri(`misc/profile/${this.d.id}/record/view`)).then((r) => {});
    },
    open(d, n) {
      this.d = d;
      this.viewMore = false;
      this.next = n;
      this.show = true;
      document.querySelector('body').classList.add('ofw-hdn');
      setTimeout(() => {
        if (d && d.media) {
          const m = d.media;
          const src = [];
          if (m.vid1080p) src.push({ src: m.vid1080p, type: 'video/mp4', size: 1080 });
          if (m.vid720p) src.push({ src: m.vid720p, type: 'video/mp4', size: 720 });
          if (m.vid480p) src.push({ src: m.vid480p, type: 'video/mp4', size: 480 });
          if (m.vid360p) src.push({ src: m.vid360p, type: 'video/mp4', size: 360 });
          setTimeout(() => {
            const v = this.$refs.video.player;
            v.source = { type: 'video', title: d.name, sources: src };
            v.play();
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
.plyr__control--overlaid{
  background: #5351a4 !important;
}
.plyr--full-ui input[type=range]{
  color: #f14724 !important;
}
</style>

<style scoped lang="scss">
.loginModal{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9991;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
  padding: 40px 0;

  .overlay{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,.5);
    z-index: 1;
  }
  .modalContent{
    position: relative;
    z-index: 2;
    background-color: #fff;
    // background-color: #e6e1c1;
    // background-image: url(../assets/modal-bg.jpg);
    background-size: auto 100%;
    background-position: right;
    background-repeat: no-repeat;
    margin: auto;
    border-radius: 5px;
    overflow: hidden;
    width: 860px;
    .close{
      position: absolute;
      right: 10px; top: 10px;
      width: 40px; height: 40px;
      border-radius: 50%;
      background-image: url(../assets/close-white.png);
      background-size: 16px auto;
      background-position: center;
      background-repeat: no-repeat;
      opacity: .4;
      cursor: pointer;
      transition: all .2s ease;
      &:hover{
        background-color: rgba(0, 0, 0, .3);
        opacity: .8;
      }
    }
    .videoCnt{
      width: 100%;
      video{
        width: 100%;
        display: block;
      }
    }
    .profileInfo{
      padding: 20px 40px;
      position: relative;
      @media (max-width: 680px){
        padding: 10px 20px 20px;
      }
      button{
        position: absolute;
        right: 40px; top: 10px;
        background-color: #ff6f28;
        border-color: #ff6f28;
        @media (max-width: 680px){
          right: 20px;
          font-size: 17px;
          padding: 8px 14px;
        }
      }
      h4{
        margin: 0 0 16px;
        font-size: 26px;
        padding-right: 160px;
        font-family: 'GolosUIWebBold', sans-serif;
        @media (max-width: 680px){
          padding-right: 130px;
          font-size: 20px;
          margin-bottom: 20px;
        }
        span{
          display: block;
          font-size: 18px;
          @media (max-width: 680px){
            font-size: 15px;
          }
        }
      }
      p{
        margin: 0;
        white-space: pre-line;
      }
      .viewMore{
        display: inline-block;
        margin-top: 10px;
        cursor: pointer;
        color: #5351a4;
        color: #fff;
        background-color: #5351a4;
        font-size: 14px;
        padding: 4px 12px;
        border-radius: 50px;
        margin-bottom: 10px;
        &:hover{
          box-shadow: 2px 2px 6px rgba(0, 0, 0, .2);
        }
      }
    }
    @media (max-width: 680px){
      position: absolute;
      width: auto;
      top: 50%; left: 10px; right: 10px;
      transform: translateY(-50%);
      font-size: 15px;
    }
  }
  &.fromGame{
    .modalContent{
      background-color: #e6e1c1;
      background-image: url(../assets/modal-bg.jpg);
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
